/* Copyright (c) 2024 Xperi. All Rights Reserved. */

/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
export enum PlayerViewMode {
    Atmospheric = 'Atmospheric', //  This can be utilized in future when the home screen gets implemented.
    FullScreen = 'FullScreen',
    VideoWindow = 'VideoWindow',
}
